import React from "react";
import { CheckIcon, InfoIcon } from "lucide-react";
import { Section, SectionHeading } from "./Section";
import { volumes } from "../data/landing";
export function Volumes() {
  return <Section cta="I Want All 6 Volumes" data-id="element-303" data-mp="184569yshmgue">
      <SectionHeading eyebrow="Six specialized volumes" title="What Will You Find Inside HOF CLINICAL BLUEPRINT™?" data-id="element-304" data-mp="185gce59eo0oo" />

      <div className="mt-12 space-y-6" data-id="element-305" data-mp="1c3e2dab02qt4">
        {volumes.map(v => <article key={v.numeral} className="overflow-hidden rounded-3xl bg-panel ring-1 ring-line md:grid md:grid-cols-[180px_1fr]" data-id="element-306" data-mp="1zwcoh3nn61aw">
            <div className="flex items-center gap-4 px-6 py-5 md:flex-col md:items-start md:justify-center md:gap-1 md:py-8" style={{
          backgroundColor: `${v.accent}1F`,
          borderBottom: `3px solid ${v.accent}`
        }} data-id="element-307" data-mp="1quwg11ge099b">
              <span className="text-xs font-extrabold uppercase tracking-[0.2em]" style={{
            color: v.accent
          }} data-id="element-308" data-mp="fharniicqbou">
                Volume
              </span>
              <span className="font-serif text-5xl font-extrabold leading-none text-cream md:text-6xl" data-id="element-309" data-mp="3o7dev8xn6ype">{v.numeral}</span>
            </div>

            <div className="p-6 sm:p-8" data-id="element-310" data-mp="3jawoe82z0895">
              <h3 className="font-serif text-2xl font-bold leading-tight text-cream sm:text-3xl" data-id="element-311" data-mp="20oslqo3zm8z">{v.title}</h3>
              <p className="mt-2 text-base font-semibold text-gold sm:text-lg" data-id="element-312" data-mp="3t701ua39vtbe">{v.subtitle}</p>
              <p className="mt-4 text-base leading-relaxed text-muted" data-id="element-313" data-mp="b14tqthdqhao">{v.text}</p>

              <p className="mt-6 text-xs font-bold uppercase tracking-[0.18em] text-cream" data-id="element-314" data-mp="62tluoanagv3">{v.listLabel}</p>
              <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-315" data-mp="krzj46px9x0c">
                {v.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-cream" data-id="element-316" data-mp="fs3eq6dbc3k9">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" style={{
                color: v.accent
              }} strokeWidth={3} aria-hidden="true" data-id="element-317" data-mp="trmmuz64jewk" />
                    {item}
                  </li>)}
              </ul>

              <p className="mt-6 flex gap-2 border-t border-line pt-4 text-sm leading-relaxed text-muted" data-id="element-318" data-mp="wuser4wwtthi">
                <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-muted" aria-hidden="true" data-id="element-319" data-mp="11tlwj9j8c6nh" />
                {v.note}
              </p>
            </div>
          </article>)}
      </div>
    </Section>;
}